import React from 'react';
import { IFooterIconParams } from "./IFooterIconParams";

export function FooterIcon(params: IFooterIconParams) {
    const icon = require(`./../../${params.imagePath}`);
    return <img className={params.class} src={icon.default} alt={params.alt} 
                title={(typeof params.title != 'undefined' ? params.title : '')} onClick={() => { params.onClickAction(); }} />;
}